import { CommonData } from '../common_schema'

export const rocksdbKVData: CommonData[] = [
  {
    name: 'Compaction operations(summary for all types)',
    mean: 'kv_Compaction_operations:total.values.mean',
    std: 'kv_Compaction_operations:total.values.std',
    location: 'TiKV-Details  --> RocksDB KV --> Compaction operations'
  },
  {
    name: 'Compaction Flow(sum for read+written+flush)',
    mean: 'kv_Compaction_flows:total.values.mean',
    std: 'kv_Compaction_flows:total.values.std',
    location: 'TiKV-Details  --> RocksDB KV --> Compaction Flow'
  },
  {
    name: 'Compaction pending bytes(total)',
    mean: 'kv_Compaction_pending_bytes:total.values.mean',
    std: 'kv_Compaction_pending_bytes:total.values.std',
    location: 'TiKV-Details  --> RocksDB KV --> Compaction pending bytes'
  },
  {
    name: 'Write Stall duration',
    mean: 'kv_write_stall_duration:total.values.mean',
    std: 'kv_write_stall_duration:total.values.std',
    location: 'TiKV-Details  --> RocksDB KV --> Write Stall duration'
  },
  {
    name: 'Write Stall reason(summary for all reasons)',
    mean: 'kv_write_stall_reason:total.values.mean',
    std: 'kv_write_stall_reason:total.values.std',
    location: 'TiKV-Details  --> RocksDB KV --> Write Stall reason'
  },
  {
    name: `Impact to top level's Duration and QPS?`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual]'
  }
]
